// @ts-nocheck
import { createCommissionTemplate } from './commissionTemplateHelpers.js';

export default createCommissionTemplate({
  pharmaceuticalCompanyName: '광동제약',
  targetSheetName: 'Sheet1',
  headerRowIndex: 0,
  headerRowCount: 1,
  dataStartRowIndex: 1,
  requiredHeaders: [
    '제약사명',
    '급여여부',
    '제품명',
    '성분',
    '효능',
    '효능명',
    '보험코드',
    '약가',
    '기본요율',
    '유통이슈',
    '비고',
    '자체생산 여부',
    '생동',
    '대조의약품',
  ],
  columnMapping: {
    drugName: '제품명',
    drugCode: '보험코드',
    pharmaceuticalCompanyName: '제약사명',
    price: '약가',
    commissionRate: '기본요율',
    commissionNote: '비고',
  },
});
